import {API} from '../../networking/http'
import {QueryMethod} from '../helpers/types'
import {Member} from './types'

export type GetMemberByVenueParams = undefined
export type GetMemberByVenueQueryParams = {
  venueId?: string
  userId?: string
}

export type GetMemberByVenueQuery = QueryMethod<GetMemberByVenueParams, GetMemberByVenueQueryParams, Member>

export const makeGetMemberByVenueEndpoint = () => 'members/byVenue'

// Caller options (enabled, retry, ...) are forwarded; the key, cache time and fetcher stay owned here.
export const getMemberByVenueQuery: GetMemberByVenueQuery = ({query, ...rest}) => ({
  ...rest,
  queryKey: ['getMemberByVenueQuery', query],
  cacheTime: 1000 * 300,
  refetchOnWindowFocus: rest.refetchOnWindowFocus || false,
  queryFn: ({queryKey: [_, config]}) =>
    API.get<GetMemberByVenueQueryParams, Member>(makeGetMemberByVenueEndpoint(), {
      params: config,
    }).then((res) => res.data),
})
